import {Component} from '@angular/core';
import {CompareBaseComponent} from '@bbndev/ngx-bbn-zvendo';

@Component({
	selector: 'app-compare',
	templateUrl: './compare.component.html',
	styleUrls: ['./compare.component.scss']
})
export class CompareComponent extends CompareBaseComponent {
}
